import { Injectable } from '@angular/core';
import {
  AbstractControlOptions,
  UntypedFormArray,
  Validators,
} from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { Parameters } from '@app/forms/subscription/definition/interface/Pledge';
import { CompanyFieldType } from '@app/forms/subscription/definition/interface/enum';
import FormGroupArray from '@app/forms/subscription/services/FormGroupArray';

@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generateForm(entity: any, option) {
    const parameters: Parameters = {
      ...option,
    };

    let options: AbstractControlOptions = {};

    const form = this.formBuilder.group(
      {
        ownerId: [entity.ownerId],
        userLastName: [entity?.userLastName || null],
        userFirstName: [entity?.userFirstName ? entity.userFirstName : null],

        retirementAge: [
          entity?.retirementAge || 64,
          this.retirementAgeRequired(parameters)
            ? Validators.compose([
                Validators.required,
                Validators.min(40),
                Validators.max(90),
              ])
            : Validators.nullValidator,
        ],
      },
      options,
    );

    return form;
  }
  generate(entity: any[], option) {
    return FormGroupArray.generate({
      entity,
      options: option,
      formBuilder: this.formBuilder,
      generateForm: this.generateForm.bind(this),
    });
  }
  retirementAgeRequired(parameters: Parameters) {
    if (!parameters) return false;
    return (
      this.getAdditionalQuestions(parameters, CompanyFieldType.RETIREMENT_AGE)
        ?.required === 'MANDATORY' || false
    );
  }
  getAdditionalQuestions(parameters: Parameters, type: any) {
    return parameters?.additionalQuestions?.find(q => q?.id === type);
  }
  getAdditionalQuestions2(parameters: Parameters, type: CompanyFieldType) {
    return parameters?.additionalQuestions?.find(q => q?.id === type);
  }

  extract() {
    return this.form.value.owners;
  }
  get owners() {
    return this.form.get('owners') as UntypedFormArray;
  }
}
